module.exports = __webpack_public_path__ + "img/office.a021da7d.svg";